import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { FaShoppingBag, FaStore, FaArrowRight } from 'react-icons/fa'

// Bottom-of-home marketplace CTA pair: Bazar + Mağazalar.
// Replaces the inline gradient tiles in Home.jsx with one consistent treatment.

const Tile = ({ to, eyebrow, title, subtitle, icon, tone }) => (
    <Link
        to={to}
        className={`group relative overflow-hidden rounded-card border ${tone.border} ${tone.bg} p-5 sm:p-4 transition-all hover:shadow-card-hover hover:-translate-y-0.5`}
    >
        <div className='flex items-start gap-4 sm:gap-3'>
            <div className={`shrink-0 inline-flex h-12 w-12 sm:h-10 sm:w-10 items-center justify-center rounded-card ${tone.icon}`}>
                {icon}
            </div>
            <div className='min-w-0'>
                <p className={`text-[11px] font-bold uppercase tracking-wider ${tone.eyebrow}`}>{eyebrow}</p>
                <h3 className='mt-0.5 text-base font-bold text-slate-900 truncate'>{title}</h3>
                <p className='mt-1 text-xs text-slate-500'>{subtitle}</p>
            </div>
            <span className={`ml-auto shrink-0 inline-flex h-8 w-8 items-center justify-center rounded-pill ${tone.arrow} transition-transform group-hover:translate-x-0.5`}>
                <FaArrowRight size={11} />
            </span>
        </div>
    </Link>
)

const MarketplaceCTA = () => {
    const { t } = useTranslation()
    return (
    <section className='w-full max-w-marketplace mx-auto px-4 sm:px-4 md-lg:px-5 md:px-5 lg:px-8 mt-2 mb-6'>
        <div className='grid grid-cols-2 md:grid-cols-1 gap-4 sm:gap-3'>
            <Tile
                to='/market'
                eyebrow={t('home.cta.market.eyebrow')}
                title={t('home.cta.market.title')}
                subtitle={t('home.cta.market.subtitle')}
                icon={<FaShoppingBag />}
                tone={{
                    bg:      'bg-gradient-to-br from-brand-50 via-white to-white',
                    border:  'border-brand-100',
                    icon:    'bg-brand-100 text-brand-700',
                    eyebrow: 'text-brand-700',
                    arrow:   'bg-brand-600 text-white',
                }}
            />
            <Tile
                to='/magazalar'
                eyebrow={t('home.cta.shops.eyebrow')}
                title={t('home.cta.shops.title')}
                subtitle={t('home.cta.shops.subtitle')}
                icon={<FaStore />}
                tone={{
                    bg:      'bg-gradient-to-br from-accent-50 via-white to-white',
                    border:  'border-accent-100',
                    icon:    'bg-accent-100 text-accent-700',
                    eyebrow: 'text-accent-700',
                    arrow:   'bg-accent-500 text-white',
                }}
            />
        </div>
    </section>
    )
}

export default MarketplaceCTA
